import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressLabel from '../progress-label';
import ContactData from '../contact-data';
import { IoIosNotificationsOutline } from 'react-icons/io';
import { OverlayTrigger } from 'react-bootstrap';
import { Element, CustomTooltip, ContainerProgress } from './styles';

const Branch = ({ item }) => {
  const notificationsLength = item.notifications.filter((notification) =>
    [1, 2].includes(notification.statusId),
  ).length;
  const notifactionTooltipLabel =
    notificationsLength > 1 ? 'Notificações' : 'Notificação';
  const navigate = useNavigate();

  const handleNavigate = (id) => {
    navigate(`/prefeitura/secretaria/${id}`);
  };

  const NotificationTooltip = (
    <CustomTooltip id='tooltip'>
      <strong>{notifactionTooltipLabel}</strong>
    </CustomTooltip>
  );

  return (
    <Element onClick={() => handleNavigate(item.id)} id={`branch-card-${item.id || 'unknown'}`}>
      {notificationsLength > 0 && (
        <div
          id={`branch-notifications-${item.id || 'unknown'}`}
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <IoIosNotificationsOutline
            id={`branch-notification-icon-${item.id || 'unknown'}`}
            style={{
              color: '#f16024',
              fontSize: '27px',
              position: 'absolute',
            }}
          />
          <OverlayTrigger placement='right' overlay={NotificationTooltip}>
            <strong
              id={`branch-notification-count-${item.id || 'unknown'}`}
              style={{
                position: 'relative',
                fontSize: '12px',
                color: 'white',
                width: '20px',
                height: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#737373',
                borderRadius: '25px',
                textAlign: 'center',
                padding: '0 15px',
                left: '17px',
                top: '-5px',
              }}
            >
              {notificationsLength > 99 ? '99+' : notificationsLength}
            </strong>
          </OverlayTrigger>
        </div>
      )}

      <ContainerProgress id={`branch-progress-${item.id || 'unknown'}`}>
        <ProgressLabel amount={item.compliance.maturity} />
      </ContainerProgress>
      <img src={item.iconUrl} alt='' id={`branch-icon-${item.id || 'unknown'}`} />
      {item?.type?.id === 3 && <span id={`branch-type-label-${item.id || 'unknown'}`}>Secretaria de</span>}
      <h1 id={`branch-name-${item.id || 'unknown'}`}>{item.name}</h1>
      <small id={`branch-responsible-${item.id || 'unknown'}`}>{item.responsible.name || '< Responsável não definido >'}</small>
      <div id={`branch-contact-${item.id || 'unknown'}`}>
        {item.responsible.email && (
          <ContactData contact={item.responsible.email} />
        )}
      </div>
    </Element>
  );
};

export default Branch;
